var _G, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgFunctionalStrengthOutlined(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#functional-strength-outlined_svg__clip0_3626_5244)",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M2.471 13.306a.53.53 0 01.708-.248l1.313.63.264-.55a1.443 1.443 0 01-.192-1.985 1.443 1.443 0 011.402-.532l.238-.495-1.312-.63a.53.53 0 01-.248-.709l.611-1.274a.53.53 0 01.709-.248l4.204 2.02a.53.53 0 01.249.708l-.612 1.274a.53.53 0 01-.708.248l-1.166-.56-.216.45 1.961.942c.427.205.935.14 1.295-.169l3.108-2.658c.09-.076.185-.138.285-.19.418-.36.962-.578 1.557-.578h2.796c.595 0 1.139.218 1.556.578.1.051.196.114.285.19l3.108 2.658c.36.307.868.374 1.295.17l1.962-.944-.216-.45-1.167.561a.53.53 0 01-.708-.248l-.612-1.274a.53.53 0 01.249-.708l4.204-2.02a.53.53 0 01.708.248l.612 1.274a.53.53 0 01-.248.708l-1.313.63.239.496a1.448 1.448 0 011.21 2.518l.264.55 1.312-.63a.53.53 0 01.708.248l.61 1.27a.53.53 0 01-.248.708l-4.205 2.02a.53.53 0 01-.708-.248l-.61-1.27a.53.53 0 01.248-.709l1.167-.56-.252-.524-1.961.942a4.068 4.068 0 01-4.405-.574l-.264-.226a.263.263 0 00-.435.2v6.05l.824 10.58a1.599 1.599 0 11-3.189.248l-.764-9.823a.668.668 0 00-.63-.622.663.663 0 00-.674.602l-.766 9.843a1.6 1.6 0 01-3.188-.248l.823-10.58v-6.05a.263.263 0 00-.434-.2l-.264.226a4.067 4.067 0 01-4.405.575l-1.962-.943-.252.524 1.167.56a.53.53 0 01.248.709l-.61 1.27a.53.53 0 01-.708.248l-4.205-2.02a.53.53 0 01-.248-.708l.606-1.27v0z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M17.32 7.294a2.871 2.871 0 110-5.742 2.871 2.871 0 010 5.742z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "functional-strength-outlined_svg__clip0_3626_5244"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 33.26 1.12)",
    d: "M0 0h31.879v32H0z"
  })))));
}

export default SvgFunctionalStrengthOutlined;